<template>
    <div id="reload-session">
      <nav id="reload-nav" class="navbar navbar-expand-lg navbar-light bg-light">
        <div>
          <div class="navbar-nav">
            {{message}} <span style="padding-right: 4px; padding-left: 3px;"><a @click="reloadPage" href="#">Reload </a> </span> <span> {{msg}}</span>
          </div>
        </div>
      </nav>
    </div>
</template>

<script>
  export default {
    name: 'ReloadSession',
    data() {
      return {
        msg: 'to refresh your session.'
      }
    },
    props: ['message'],
    methods: {
      reloadPage(){
        window.location.reload(true);
      }
    }
  }
</script>

<style lang="scss">
  $background-color-reload: #fffbdd;
  $min-reload-height: 56px;

  #reload-session{
    background: $background-color-reload;
    z-index: 2000;
    position: absolute;
    top: 0;
    left: 0;
    min-height: $min-reload-height;
    width: 100%;
  }

  #reload-nav{
    background: $background-color-reload !important;
    min-height: $min-reload-height;
  }
</style>
